import { AxiosInstance } from "axios"
import { ServiceResponse } from "../../../../../core/api/apiTypes"
import { SupportCreateCompany, SupportCompanyWithHistory } from "./companyTypes"

type FetchEntityByIdParams = Readonly<{
    entityId: number
}>

export async function fetchEntitiesById(
    { entityId }: FetchEntityByIdParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupportCompanyWithHistory> {
    const url = `/entities/${entityId}`

    const response = await axios.get(url, { signal })

    return response.data
}

export async function createCompanyApi(
    { entity }: SupportCreateCompany,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = "/companies"

    const response = await axios.post(
        url,
        {
            entity,
        },
        {
            signal,
        },
    )

    return response.data
}

export async function updateCompanyApi(
    { entityId, entity }: { entityId: string; entity: SupportCreateCompany['entity'] },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = `/entities/${entityId}`

    const response = await axios.post(
        url,
        {
            entity,
        },
        {
            signal,
        },
    )

    return response.data
}
